import { render } from "./CallItem.vue?vue&type=template&id=6b6da058"
import script from "./CallItem.vue?vue&type=script&lang=js"
export * from "./CallItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__